import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { SpecializationSubscription } from "../../Models/Trainee";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { ProfileVM } from "./ProfileVM";

export class SubscriptionCardVM extends InterActive{
    private data?:SpecializationSubscription

    public get Data():SpecializationSubscription|undefined{ return this.data }

    constructor(){
        super()
        
    }
    public setData(data:SpecializationSubscription){
        this.loading(
            async()=>{
                this.data = data
                this.update()
            }
        )
    }
    public async changePeriod(course_id:string, period_id:string  , level_specialization_trainee_id:string , trainee_id:string){
        try{
            const response = await ApiRequest.traineePeriod(course_id, period_id , level_specialization_trainee_id , trainee_id)
            console.log(response)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        Notify({type:"success" , title:'تمت العملية بنجاح' , body:'تمت عملية تحديد الدفعة بنجاح'})
                    }else Notify({type:"danger" , title:'فشل العملية' , body:'فشل عملية الالتحاق بالدفعة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }else  Notify({type:"danger" , title:'فشل العملية' , body:'فشل عملية الالتحاق بالدفعة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:"danger" , title:'فشل العملية' , body:'فشل عملية الالتحاق بالدفعة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
    }

    public async deleteTransaction(id:string, onFail:()=>void , vm?:ProfileVM){
        try{
            const response = await ApiRequest.deleteTransaction(id)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        Notify({type:'success' , title:'عملية ناجحة' , body:'تم مسح التحويل بنجاح'})
                        if(vm){
                            vm.getProfile()
                        }
                    }
                    else{
                        Notify({type:'danger' , title:'عملية فاشلة' , body:response.data.messege})
                        onFail()
                    }
                }else {
                    Notify({type:'danger' , title:'عملية فاشلة' , body:'مشكلة غير معروفة'})
                    onFail()
                }
            }
        }catch{
            Notify({type:'danger' , title:'عملية فاشلة' , body:'مشكلة غير معروفة'})
            onFail()
        }
    }

    public async editTransaction(id:string , account_id:string, value:string , currencyPrice:string , date:string , img:File|null|string , additional:string , notes:string , onFail:()=>void){
        const data:FormData = new FormData()
        data.append('id',id)
        data.append('account_id',account_id)
        data.append('value',value)
        data.append('currencyPrice',currencyPrice)
        data.append('date',date)
        if(img instanceof File)data.append('img',img)
        data.append('additional',additional)
        data.append('notes',notes)

        try{
            const response = await ApiRequest.editTransaction(data)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        Notify({type:'success' , title:'عملية ناجحة' , body:'تم تعديل التحويل بنجاح'})
                    }else {
                        Notify({type:'danger' , title:'عملية فاشلة' , body:response.data.messege})
                        onFail()
                    }
                }else {
                    Notify({type:'danger' , title:'عملية فاشلة' , body:'مشكلة غير معروفة'})
                    onFail()
                }
            }
        }catch{
            Notify({type:'danger' , title:'عملية فاشلة' , body:'مشكلة غير معروفة'})
            onFail()
        }
    }

    public certifyCourse(id:string , course_id:string , level_specialization_id:string , period_id:string, level_specialization_trainee_id:string , level_id:string){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.certifyCourse(id ,course_id , level_specialization_id , period_id, level_specialization_trainee_id )
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                if(this.data){
                                    const level = this.data.levels.find(a=>a.id==level_id)
                                    if(level){
                                        const course = level.subscription.courses.find(a=>a.id==course_id)
                                        if(course){
                                            course.periods = []
                                        }
                                    }
                                }
                                Notify({type:'success' , title:'عملية ناجحة' , body:'تم توثيق الكورس بنجاح'})
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else  Notify({type:'danger' , title:'فشل العملية' , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }
}